import BlogDetailHead from "components/BlogDetail/components/BlogDetailHead";
import React, { useRef } from "react";
import MoreBlogs from "components/BlogDetail/components/MoreBlogs";
import CommentsArea from "components/BlogDetail/components/CommentsArea";
import "./style.scss";
import Breadcrumb from "components/BaseWidgets/Breadcrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useBlogDetails } from "hooks/api/useBlogs";
import { useProfileCompletion } from "hooks/api/useHome";

function BlogDetail() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const requestType = location.state?.requestType || 1;

  //blog details
  const { data: blogDetail, isLoading: blogdetailLoading } = useBlogDetails(id);

  const { data: profileData } = useProfileCompletion();

  const loggedUserName = profileData?.common_home_data?.name;
  const loggedUserImage = profileData?.common_home_data?.user_image;

  const paragraphs = blogDetail?.body?.split(/\n\s*\n/) || [];

  const commentsRef = useRef(null);

  const scrollToComments = () => {
    if (commentsRef.current) {
      commentsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="container blog-detail">
      <div className="mobile-only">
        <Breadcrumb
          items={[
            {
              title: (
                <span
                  className="breadcrumb-first"
                  onClick={() => navigate("/blog")}
                >
                  Blogs
                </span>
              ),
            },
            {
              title: (
                <span className="breadcrumb-second">{blogDetail?.head}</span>
              ),
            },
          ]}
        />
      </div>
      <BlogDetailHead
        blogId={blogDetail?.id}
        blogTitle={blogDetail?.head}
        userImage={blogDetail?.blog_written_by_image}
        bannerImage={blogDetail?.image}
        quotedName={blogDetail?.blog_written_by_name}
        quotedTime={blogDetail?.time}
        blogLikes={blogDetail?.total_likes}
        blogDislikes={blogDetail?.total_dislikes}
        blogComments={blogDetail?.total_comments}
        isDislike={blogDetail?.is_disliked}
        isLike={blogDetail?.is_liked}
        isSaved={blogDetail?.is_saved}
        onCommentClick={scrollToComments}
      />
      <div className="description-area">
        <div className="blog-desc">
          {paragraphs.map((para, index) => (
            <p
              key={index}
              className="font-body-md2 fw-400 grey-shade1 blog-para"
            >
              {para.trim()}
            </p>
          ))}
          <div ref={commentsRef}>
            <CommentsArea
              loggedUser={loggedUserImage}
              userName={loggedUserName}
              comments={blogDetail}
            />
          </div>
        </div>
        <div className="more-blogs-sidebar">
          <MoreBlogs currentBlogId={id} requestType={requestType} />
        </div>
      </div>
    </div>
  );
}

export default BlogDetail;
